<template lang="html">
  <div id="search" class="search">
    <form @submit.prevent>
      <i class="icon__search fa fa-search" aria-hidden="true"></i>
      <input
        id="searchbar"
        class="search__input"
        autocomplete="off"
        type="search"
        :placeholder="$getTrans('search-placeholder')"
        v-model="searchQuery"
        @focus="closeNav()"
        required>

        <button
          class="icon__clear-input"
          type="reset"
          @click="clearSearch(); closeSearchResults()">
          <i class="fa fa-times-circle" aria-hidden="true"></i>
        </button>
    </form>
    <div
      id="searchresults"
      class="search__results"
      v-if="searchQuery">
      <ul class="search__results-list">

        <li
          class="search__results-list--item"
          v-for="item in searchResults"
          @click="clearSearch(); closeSearchResults()"
          v-if="item.fields.title">

          <template v-if="item.sys.id != '0e0'">
            <router-link
              v-if="item.fields.title"
              tag="a"
              class="search__results-list--item"
              :to="{
                name: 'artikel',
                params: {
                  title: $urlBeautify(item.fields.title),
                  id: item.sys.id,
                  pid: 1
                }
              }"
              @click.native="clearSearch(); closeSearchResults()"
            >
              {{ item.fields.title }}
            </router-link>
          </template>

          <template v-else>
            {{ item.fields.title }}
          </template>

        </li>

        <li
          class="search__results-list--item search-checkbox"
          >
          <input
            id="fts"
            type="checkbox"
            v-model="fullTextSearch"
            :value="fullTextSearch">
          <label
            for="fts">
            {{ buttonFullTextSearch }}
          </label>
        </li>

      </ul>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import api from '@/api'
import EventBus from '@/eventbus'
import Utility from '@/utility'

export default {
  name: 'Search',
  data() {
    return {
      searchQuery: '',
      searchResults: [],
      displayNoResult: '',
      region: '/',
      translation: null,
      fullTextSearch: false,
      buttonFullTextSearch: this.$getTrans('button-full-text-search', 'de'),
      textNoSearchResults: this.$getTrans('search-no-results', 'de')
    }
  },
  created() {
    EventBus.$on('filledSearch', (search) => {
      let searchWords = search.split('Search:')[1]
      this.searchQuery = searchWords
    })

    EventBus.$on('closeSearch', () => {
      // console.log('closeSearch')
      this.clearSearch()
      this.closeSearchResults()
    })
  },
  mounted() {
    // get current region
    this.getRegion()
  },
  methods: {
    getRegion() {
      // Get route region
      let region = this.$route.params.region
      if(region) {
        this.region = `/${region.toLowerCase()}`
      }
    },
    closeNav() {
      // send the click event to the parent
      this.$emit('closeNav', true);

      document.getElementsByTagName('body')[0].style.overflow = 'auto'
    },
    closeSearchResults() {
      // close the search result list
      this.searchResults = []

      document.getElementsByTagName('body')[0].style.overflow = 'auto'
    },
    clearSearch() {
      // clear the input field
      this.searchQuery = ''
      this.fullTextSearch = false
    }
  },
  watch: {
    '$route.params.region'(region) {
      this.getRegion()
    },
    searchQuery(query) {
      // console.log('searchQuery');
      const limit = 20
      let vm = this
      let fts = document.querySelector('#fts')

      if(query) {
        if(query.length >= 3) {
          setTimeout(function() {
            let ftsVal = 'false'

            if(fts) {
              ftsVal = fts.value
            }

            api.searchNew(query, vm.region)
              .then((response) => {
                // Prevent parent container of scrolling
                document.getElementsByTagName('body')[0].style.overflow = 'hidden'

                // published at
                let files = response.data.items
                files = files.filter((file) => {
                  // return !!file.sys.publishedAt
                  return !!file.sys.updatedAt
                })

                let emptyResult = {
                  'fields' : {
                    'title' : '',
                  },
                  'sys' : {
                    'id' : ''
                  }
                }
                let items = []

                files.map((file) => {
                  // console.log('file map: ', file)
                  if (items.length <= limit) {

                    // Search titles
                    if (file.fields.hasOwnProperty('title')) {
                      // let title = file.fields.title.en
                      let title = file.fields.title

                      if (title && !file.fields.hidden) {
                        if (title.toUpperCase().indexOf(query.toUpperCase()) >= 0) {
                          items.push(file)
                          return
                        }
                      }
                    }

                    // Search keywords
                    if (file.fields.hasOwnProperty('keywords')) {
                      // let keywords = file.fields.keywords.en
                      let keywords = file.fields.keywords
                      // console.log('keywords: ', keywords)
                      if(keywords) {
                        keywords.map((keyword) => {
                          if (keywords.length <= limit) {
                            if (keyword.toUpperCase().indexOf(query.toUpperCase()) >= 0) {
                              // console.log('keyword: ', keyword)
                              items.push(file)
                              return
                            }
                          }
                        })
                      }
                    }

                    // Search subtitles
                    // if (file.fields.hasOwnProperty('subtitle')) {
                    //   // let subtitle = file.fields.subtitle.en
                    //   let subtitle = file.fields.subtitle
                    //   if(subtitle) {
                    //     if (subtitle.toUpperCase().indexOf(query.toUpperCase()) >= 0) {
                    //       // console.log('subtitle: ', subtitle)
                    //       items.push(file)
                    //       return
                    //     }
                    //   }
                    // }

                    // Full text search
                    if(ftsVal === 'true') {
                      // console.log('fullTextSearch: ', fts);
                      // Search text
                      if (file.fields.hasOwnProperty('text')) {
                        // let text = file.fields.text.en
                        let text = file.fields.text
                        let title = file.fields.title

                        if (text) {
                          text = Utility.decodeHtmlEntity(text.toLowerCase())
                          if (text.toUpperCase().indexOf(query.toUpperCase()) >= 0) {
                            items.push(file)
                            return
                          }
                        }
                      }
                    }
                  }
                })

                let resCount = items.length
                // console.log('resCount: ', resCount)

                let i = 0
                if (resCount > 0) {
                  // remove duplicates
                  items = Array.from(new Set(items))

                  // for (i; i<resCount; i++) {
                  //   console.log('item: ', items[i])
                  // }
                  // console.log('newCount: ', items.length)
                } else {
                  emptyResult.sys.id = '0e0'
                  emptyResult.fields.title = `Keine Ergebnisse für "${query}"`

                  // console.log('emptyResult: ', emptyResult)
                  items.push(emptyResult)
                }

                vm.searchResults = items
              })
              .catch((error) => {
                api.errorHandling(error, `Search.vue @ ${window.location.href}`)
              })

          }, 750)
        } else {
          // close search results if string contains < 3 chars
          this.closeSearchResults()
        }
      }

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/Search.vue